define(function(require, exports, module) {
    'use strict';

    var core = require('core');
    var Class = require('Class');

    var FIRST_LEVEL = {
        containerSel: '.menu__nav',
        elementSel: '.menu__nav-item',
        linkSel: '.menu__nav-link'
    };
    var SECOND_LEVEL = {
        containerSel: '.menu__secondlevel',
        elementSel: '.menu__secondlevel-item',
        linkSel: '.menu__secondlevel-link'
    };
    var ANIMATION_CLASS = 'animation-injected';
    var EFFECT_CLASS = 'effect';

    var getSel = function(cls) {
        return '.' + cls;
    };

    var SlideLineAnimation = Class.create({

        initialize: function(level, $el) {
            this.$el = $el;
            this.level = level;
        },

        init: function() {
            this.clearAnimation();

            this.$menuContainer = this.$el.find(this.level.containerSel + ':not(.hidden)');
            this.$menuElements = this.$menuContainer.find(this.level.elementSel);

            this.initLinks();
            this.initBarEl();

            this.$menuElements
                .on('mouseover.slideLineMenu', this.enterHandler.bind(this))
                .on('mouseout.slideLineMenu', this.leaveHandler.bind(this));
        },

        initLinks: function() {
            this.$menuContainer
                .find(this.level.linkSel)
                .originalAddClass(ANIMATION_CLASS);
        },

        initBarEl: function() {
            var bar = document.createElement('span');
            bar.classList.add(EFFECT_CLASS);

            var menuEl = this.$menuElements[0];
            if (!menuEl) {
                return;
            }
            var linkEl = menuEl.querySelector(this.level.linkSel);
            var barTop, barHeight;

            if (this.level === FIRST_LEVEL) {
                var linkElCs = window.getComputedStyle(linkEl);
                barHeight = parseFloat(linkElCs.fontSize) * 0.4;
                barTop = menuEl.offsetHeight - barHeight;
            } else {
                barHeight = linkEl.offsetHeight;
                barTop = linkEl.offsetTop + linkEl.parentElement.offsetTop;
            }

            bar.style.height = barHeight + 'px';
            bar.style.top = barTop + 'px';
            this.$menuContainer.originalAppend(bar);
        },

        moveBarToCurrentMenuItem: function(width, left) {
            this.$menuContainer
                .find(getSel(EFFECT_CLASS))
                .originalRemoveClass('vanished')
                .css('width', width + 'px')
                .css('left', left + 'px');
        },

        enterHandler: function(e) {
            let target = e.currentTarget.querySelector(getSel(ANIMATION_CLASS));

            // Skip inner containers as parents
            if (target.parentElement.className === 'inner') {
                target = target.parentElement;
            }

            const { marginLeft, marginRight } = window.getComputedStyle(target);
            const { left: menuItemLeft, right: menuItemRight } = target.parentElement.getBoundingClientRect();
            const { left: menuLeft, right: menuRight } = this.$menuContainer[0].parentElement.getBoundingClientRect();

            let width = target.offsetWidth;
            let left = target.offsetLeft + menuItemLeft;

            // for partially visible menu items
            if (menuItemLeft < menuLeft) {
                left = menuLeft;
                width = width - (menuLeft - menuItemLeft) + parseFloat(marginLeft);
            }

            if (menuItemRight > menuRight) {
                width = width - (menuItemRight - menuRight) + parseFloat(marginRight);
            }

            this.moveBarToCurrentMenuItem(width, left);
        },

        leaveHandler: function() {
            this.$menuContainer.find(getSel(EFFECT_CLASS)).originalAddClass('vanished');
        },

        clearAnimation: function() {
            this.$menuElements && this.$menuElements.off('.slideLineMenu');
            this.$menuContainer && this.$menuContainer.find(getSel(EFFECT_CLASS)).remove();
        }

    });

    module.exports = {

        init: function(widget) {
            const $el = widget.$el;

            if ($el.hasClass('slide-line-menu')) {
                return;
            }

            $el.originalAddClass('slide-line-menu');

            const sliders = [new SlideLineAnimation(FIRST_LEVEL, $el), new SlideLineAnimation(SECOND_LEVEL, $el)];

            sliders.forEach((slider) => slider.init());

            core.on('menu:secondLevel:toggle', () => {
                sliders.forEach((slider) => slider.init());
            });
        }

    };

});
